import { render } from "./IntakeConversion.vue?vue&type=template&id=a2182bac"
import script from "./IntakeConversion.vue?vue&type=script&lang=js"
export * from "./IntakeConversion.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__